"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("@antv/util");
var base_1 = require("./base");
exports.Facet = base_1.Facet;
// 所有的 Facet 类
var Facets = {};
/**
 * 根据 type 获取 facet 类
 * @param type
 */
exports.getFacet = function (type) {
    return Facets[_.lowerFirst(type)];
};
/**
 * 注册一个 Facet 类
 * @param type
 * @param ctor
 */
exports.registerFacet = function (type, ctor) {
    Facets[_.lowerFirst(type)] = ctor;
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/facet/index.js
// module id = 603
// module chunks = 37